export default "/images/bandphoto-1.jpg?46117c46f4ebb41db1a4cba3703efd01";